import axios from "axios";
import { invitationUrl } from "../../../utils";

export const fetchInvitation = async (invitationId: string) => {
  return await axios.get(invitationUrl(invitationId));
};
